export const projectSortEnUs = {
  NEWEST: 'Newest',
  OLDEST: 'Oldest',
}

export const projectSortEsMx = {
  NEWEST: 'Nuevo',
  OLDEST: 'Antiguo',
}
